import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ɵbypassSanitizationTrustResourceUrl } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { JobHoursModelComponent } from 'src/app/time-sheet/learner-single-week/job-hours-model/job-hours-model.component';
import { UtilityService } from '../../services/utility.service';
import { LabourJobService } from '../labour-job.service';
import { UserTimeSheetService } from '../../services/user-time-sheet.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { _operativeTimesheetModalData, _adminTimesheetApprovalModalData, _adminTimesheetRejectionModalData } from '../../_models/staticArray'
import * as _ from 'lodash';
import * as moment from "moment";
import { CommentsComponent } from 'src/app/commons/comments/comments.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'labour-time-sheet',
  templateUrl: './labour-time-sheet.component.html',
  styleUrls: ['./labour-time-sheet.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class LabourTimeSheetComponent implements OnInit {

  @Input('operativeLogs') timeLogs: Array<[]>
  @Input('jobId') labourjob: string
  @Input('isTimesheet') timesheetView: boolean
  @Input('assetList') jobAssets: Array<[]>
  @Input('allJobsData') jobrequiredData
  @Input('assignOperatives') assetOperatives
  @Input('singleJobData') currentJobdata
  @Output() addCalculation: EventEmitter<any> = new EventEmitter<any>();
  labourjobForm: FormGroup
  operativeTimelogs: any = []
  displayedColumns: string[] = ['date']
  logsColumns = ['Approve', 'Copy', 'Name', 'Planned Start', 'Actual Start', 'Planned End', 'Actual End', 'Travel Hours', 'Hours Worked', 'Travel + Working', 'Status', 'Edit', 'Reset', 'expand']
  jobAssetColumns: string[]
  dataSource: MatTableDataSource<any>;
  assetsDataSource: MatTableDataSource<any>;
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('expandedDetail');
  expandedElement: any;
  fatigueIndex = false
  mainlogIndex: any
  copiedIndex: any;
  showPasteBtn: boolean = false;
  notFileShow: boolean;
  deletedLog = []
  currentJob
  user = JSON.parse(localStorage.getItem('userRoles'))
  isSubmit = true
  noDataMsg = {
    title: "No Users!",
    data: "No Users Added in this Job"
  }
  noAssetmsg = {
    title: "No Assets!",
    data: "No Assets Added in this Job"
  }
  isView = false
  pageSize = 5;
  pageSizeOptions: number[] = [25, 50, 100];
  sort: MatSort;
  paginator: MatPaginator;
  isnodataMsg = false
  loading = false
  assetCategoryList = []
  isAdd = true
  linkedAssetList = []
  isDisabled = false
  listofJobData: any = []
  jobOperativeList = []
  singlejobDetails
  selectedTimelog = [];
  timelogStatusList = [];
  selectedFilter = "All";
  isDataSourceAvailable: boolean = true;
  timelogStatus: string = "all";
  noSubFolderMsg = {
    title: "No Logs found!",
    data: "Can not find any logs.",
  };


  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  constructor(
    public _utilityService: UtilityService,
    public _labourjobService: LabourJobService,
    public _userTimeSheetService: UserTimeSheetService,
    public formBuilder: FormBuilder,
    public _cd: ChangeDetectorRef,
    public _activatedRoute: ActivatedRoute

  ) {
    this.dataSource = new MatTableDataSource<any>([]);
    this.assetsDataSource = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {

    if (this.user.isAdmin || this.user.isManager) {
      // this.isSubmit = false;
      this.timelogStatusList = [
        { value: "all", viewValue: "All" },
        { value: "pending", viewValue: "Pending" },
        { value: "approved", viewValue: "Approved" },
      ];
    } else {
      this.isSubmit = true;
      this.timelogStatusList = [
        { value: "all", viewValue: "All" },
        { value: "draft", viewValue: "Draft" },
        { value: "submitted", viewValue: "Submitted" },
        { value: "approved", viewValue: "Approved" }
      ];
    }


    if (this.user && (this.user.isAdmin || this.user.isManager)) this.jobAssetColumns = ['title', 'id']
    else this.jobAssetColumns = ['title', 'id']

    // this.getJobData()
    this.createForm()
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("TIMESHEET LOG DATA", changes);
    if (changes.timeLogs && changes.timeLogs.currentValue) {
      this.operativeTimelogs = changes.timeLogs.currentValue
      this.dataSource = this.operativeTimelogs
      this.checkQueryparams()
    }
    if (changes.labourjob && changes.labourjob.currentValue) this.currentJob = changes.labourjob.currentValue
    if (changes.timesheetView && (changes.timesheetView.currentValue || !changes.timesheetView.currentValue)) this.isView = changes.timesheetView.currentValue

    if (changes.assetOperatives && changes.assetOperatives.currentValue) {
      const list = changes.assetOperatives.currentValue
      const listLength = list.length
      for (let i = 0; i < listLength; i++) {
        // delete list[i].operatives.timeLogs
        console.log("SINGLE OPERATIVE USER LIST", list[i].operatives)
        if (list[i].operatives !== undefined) this.jobOperativeList.push(list[i].operatives)
      }
    }

    if (changes.currentJobdata && changes.currentJobdata.currentValue) this.singlejobDetails = changes.currentJobdata.currentValue


    if (changes.jobAssets && changes.jobAssets.currentValue) {
      if (changes.jobAssets && changes.jobAssets.currentValue.length) this.isnodataMsg = false
      else this.isnodataMsg = true
      this.linkedAssetList = changes.jobAssets.currentValue
      if (this.assetCategoryList && this.assetCategoryList.length) {
        this.createForm(this.linkedAssetList)
        this.disableAssets()
      }
    }

    if (changes.jobrequiredData && changes.jobrequiredData.currentValue) {
      this.listofJobData = changes.jobrequiredData.currentValue
      this.assetCategoryList = this.listofJobData.assetList
      // this.loading = false
      if (this.assetCategoryList && this.assetCategoryList.length) {
        this.createForm(this.linkedAssetList)
        this.disableAssets()
      }
    }
  }

  // FORM GROUP FOR ASSETS


  createForm(data?) {
    console.log("CALL THIS FORM GROUP", data, this.assetCategoryList);
    this.labourjobForm = this.formBuilder.group({
      linkedAssets: this.formBuilder.array(this.multipleAssets((data && data.length) ? data : [])),
    })

    console.log("WHEN FORM VALUE IS CHANGED", this.labourjobForm);
    this.changeFormvalue()
    // this.updateAssetList()
  }


  changeFormvalue() {
    this.labourjobForm.valueChanges.subscribe(value => {
      // console.log("WHEN FORM VALUE IS CHANGED", value);       
      // if (value.linkedAssets && value.linkedAssets.length)
      this.disableAssets()
    });
  }

  updateAssetList() {
    // console.log("HOW MANY TIME IT IS CALLED", this.labourjobForm.value)
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    const controlList = control.value
    const controlLength = controlList.length
    for (let i = 0; i < controlLength; i++) {
      if (controlList[i].selectedAsset !== "") {
        this.assetSelection({ value: controlList[i] }, i)
      }
    }
  }

  get multipleAssetcategoryGroup() { return <FormArray>this.labourjobForm.get('linkedAssets') }

  multipleAssets(assets) {
    console.log("THIS IS THE ASSET LIST", assets, this.assetCategoryList)
    let assetList = []
    if (assets && assets.length) {
      _.forEach(assets, async (user) => {
        console.log("SINGLE ASSET CATEGORY", user, this.user)
        let index = this.assetCategoryList.findIndex((x) => x._id == user.assetCategory._id)
        let displayAsset = []
        if (index != -1) {
          this.assetCategoryList[index].isChecked = true
          // user.assetCategory['assetList'] = this.assetCategoryList[index].assetList
          const allAssetList = this.assetCategoryList[index].assetList
          console.log("category data to be find", allAssetList)
          const assetLength = allAssetList.length
          for (let i = 0; i < assetLength; i++) {
            const elemenet = assets.find((x) => x.selectedAsset._id === allAssetList[i]._id)
            // console.log("%c  EXISTING ELEMENT DATA IN ASSET", "color: blue", elemenet)
            if (elemenet == undefined) {
              allAssetList[i]['isSelected'] = false
            } else {
              allAssetList[i]['isSelected'] = true
            }
            displayAsset.push(allAssetList[i])
          }
        }
        await assetList.push(new FormGroup({
          assetCategory: new FormControl((user && user.assetCategory) ? user.assetCategory : ''),
          assetList: new FormControl(displayAsset),
          selectedAsset: new FormControl(this.getSelectedAssetwithLinkedAsset(user)),
          assignOperative: new FormControl((user && user.assignOperative) ? user.assignOperative : []),
          linkedAsset: new FormControl((user && user.linkedAsset ? user.linkedAsset : [])),
          operativeList: new FormControl(this.jobOperativeList)
        }))
      })
      console.log("ASSET LIST TO BE DISPLAY", assetList)
      return assetList;
    } else {
      return [this.formBuilder.group({
        assetCategory: new FormControl(''),
        assetList: new FormControl([]),
        selectedAsset: new FormControl(''),
        assignOperative: new FormControl([]),
        linkedAsset: new FormControl([]),
        operativeList: new FormControl(this.jobOperativeList)
      })]
    }
  }


  getSelectedAssetwithLinkedAsset(asset) {
    console.log("SELECTED ASSET DATA", asset, this.assetCategoryList)
    const category = this.assetCategoryList.find((x) => x._id === asset.assetCategory._id)
    if (category !== undefined) {
      const assetData = category.assetList.find((y) => y._id === asset.selectedAsset._id)
      if (assetData !== undefined) {
        asset.selectedAsset['linkedAsset'] = assetData.linkedAsset
        // const index = this.labourjobForm.value.linkedAssets.findIndex((x)=> x.selectedAsset._id === asset.selectedAsset._id)
        // this.assetSelection({value:asset.selectedAsset} , index) 
      }
    }
    return asset.selectedAsset
  }


  addMultipleAssets() {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    control.push(this.formBuilder.group({
      assetCategory: new FormControl(''),
      assetList: new FormControl([]),
      selectedAsset: new FormControl(''),
      assignOperative: new FormControl([]),
      linkedAsset: new FormControl([]),
      operativeList: new FormControl(this.jobOperativeList)
    }))
  }


  deleteAssets(item, index) {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    control.removeAt(index)
  }


  disableAssets() {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    console.log("CALL THIS DISABLE FUNCTIONALITY", control.value)
    let selectedAsset = control.value
    let lastElement = selectedAsset[selectedAsset.length - 1]
    if (lastElement.assetCategory != '') this.isAdd = false
    else this.isAdd = true
    if (lastElement.assetCategory == '') this.isDisabled = true
    else this.isDisabled = false

  }

  assetCategorySelect(event, item, i) {
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    const currentCategory = item.value
    const currentFormdata = this.labourjobForm.controls.linkedAssets.value
    const mainAssetList = this.assetCategoryList.find((x) => x._id === currentCategory.assetCategory._id)
    const categoryData = currentFormdata.filter((x) => x.assetCategory._id === currentCategory.assetCategory._id)
    let assetList = []
    const allAssetList = mainAssetList.assetList
    const assetLength = allAssetList.length
    for (let i = 0; i < assetLength; i++) {
      const elemenet = currentFormdata.find((x) => x.selectedAsset._id === allAssetList[i]._id)
      let isExits
      if (elemenet == undefined) {
        isExits = this.verifyAssetDate(allAssetList[i])
        if (isExits) allAssetList[i]['isSelected'] = true
        else allAssetList[i]['isSelected'] = false
      } else {
        allAssetList[i]['isSelected'] = true
      }
      assetList.push(allAssetList[i])
    }
    control.at(i).patchValue({ assetList: assetList })
  }

  // Here verify asset data with previous jobs or future jobs linked assets date
  // If asset is used in another job then that asset is not select in current job
  verifyAssetDate(asset) {
    const allJobs = this.listofJobData.allJobs
    const jobLength = allJobs.length
    let isEnd
    let isStart
    for (let i = 0; i < jobLength; i++) {
      const assetAvalible = allJobs[i].linkedAssets.filter((x) => x.selectedAsset._id === asset._id)
      // console.log("ASSET TITLE WITH VALIDATION",asset, asset.title, asset.uniqueId, assetAvalible , allJobs[i].linkedAssets)
      if (assetAvalible && assetAvalible.length) {
        for (let j = 0; j < assetAvalible.length; j++) {
          const currentStartDate = this.singlejobDetails.startDate
          const currentEndDate = this.singlejobDetails.endDate
          const existingStartDate = allJobs[i].startDate
          const existingEndDate = allJobs[i].endDate
          isStart = this.checkDate(existingStartDate, existingEndDate, currentStartDate)
          isEnd = this.checkDate(existingStartDate, existingEndDate, currentEndDate)
          if (isStart || isEnd) break;
        }
      }
      else {
        isStart = false
        isEnd = false
      }
      if (isStart || isEnd) break;
    }
    if (!isStart && !isEnd) return false
    else return true
  }


  assetSelection(item, index) {
    console.log("THIS IS THE EVENT", item, index)
    const control = <FormArray>this.labourjobForm.controls.linkedAssets
    let selectedAsset = item.value.selectedAsset
    let linkedAssetList = selectedAsset.linkedAsset || []
    const linkedAssetLength = linkedAssetList.length
    const otherjobsLinkedAsset = this.getOtherjobLinkedAsset(item)
    console.log("OTHER JOBS LINKED ASSET LIST", otherjobsLinkedAsset)
    for (let i = 0; i < linkedAssetLength; i++) {
      const currentAsset = otherjobsLinkedAsset.filter((x) => x._id === linkedAssetList[i]._id)
      console.log("CURRENT ASSET DATA", currentAsset)
      let isEnd
      let isStart
      if (currentAsset && currentAsset.length) {
        for (let j = 0; j < currentAsset.length; j++) {
          const currentStartDate = this.singlejobDetails.startDate
          const currentEndDate = this.singlejobDetails.endDate
          const existingStartDate = currentAsset[j].startDate
          const existingEndDate = currentAsset[j].endDate
          isStart = this.checkDate(existingStartDate, existingEndDate, currentStartDate)
          isEnd = this.checkDate(existingStartDate, existingEndDate, currentEndDate)
          // console.log("VALUE OF DATE EXITS", isStart, isEnd, asset.title)
          if (isStart || isEnd) break;
        }
        console.log("VERIFYING DATA OF SUB ASSET", linkedAssetList[i], isStart, isEnd)
        if (isStart || isEnd) {
          const existingAsset = item.value.linkedAsset.findIndex((x) => x._id === linkedAssetList[i]._id)
          if (existingAsset == -1) linkedAssetList[i]['isSelected'] = true
          else linkedAssetList[i]['isSelected'] = false
        }
        else linkedAssetList[i]['isSelected'] = false
      } else {
        linkedAssetList[i]['isSelected'] = false
        // isStart = false
        // isEnd = false
      }
      // if (isStart || isEnd) break;
    }
    // if(selectedAsset !== "")
    selectedAsset['linkedAsset'] = linkedAssetList
    control.at(index).patchValue({ selectedAsset: selectedAsset })
    console.log("ITEM OF CURRENT Asset CAtegory with asset", selectedAsset, index, this.labourjobForm.value)
  }



  getOtherjobLinkedAsset(asset) {
    // const jobLength = this.allJobs.length
    const allJobs = this.listofJobData.allJobs || []
    const jobLength = allJobs.length || []
    console.log("ALL LIST OF JOB DATA", this.listofJobData, allJobs, jobLength)
    let linkedAsset = []
    for (let i = 0; i < jobLength; i++) {
      // console.log("SINGLE JOB DETAILS", this.allJobs[j])
      const singleJob = allJobs[i]
      if (singleJob.linkedAssets && singleJob.linkedAssets.length) {
        const assetList = singleJob.linkedAssets
        const assetLength = assetList.length
        for (let j = 0; j < assetLength; j++) {
          assetList[j].linkedAsset = assetList[j].linkedAsset.map((x) => {
            x['startDate'] = singleJob.startDate,
              x['endDate'] = singleJob.endDate
            return x
          })
          // console.log("ASSET LIST with changes", assetList[j])
          linkedAsset = linkedAsset.concat(assetList[j].linkedAsset)
        }
      }
    }
    console.log("Curren Asset data", asset)
    const currentjobAssets = this.labourjobForm.value
    if (currentjobAssets.linkedAssets && currentjobAssets.linkedAssets.length) {
      const currentLinkedAssets = currentjobAssets.linkedAssets
      console.log("CURRENT FORM VALUE", currentjobAssets.linkedAssets)
      for (let k = 0; k < currentLinkedAssets.length; k++) {
        if (currentLinkedAssets[k].selectedAsset._id !== asset.value.selectedAsset._id) {
          currentLinkedAssets[k].linkedAsset = currentLinkedAssets[k].linkedAsset.map((x) => {
            x['startDate'] = this.singlejobDetails.startDate
            x['endDate'] = this.singlejobDetails.endDate
            return x
          })
          linkedAsset = linkedAsset.concat(currentLinkedAssets[k].linkedAsset)
        }
      }
    }
    //   linkedAsset = linkedAsset.filter((c, index) => {
    //     return linkedAsset.indexOf(c) === index;
    // });
    return linkedAsset
  }

  openLinkedassets(event) {
    console.log("EVENT WHEN OPEN DROP DOWN", event)
  }

  checkDate(fromDate, toDate, checkDate) {
    console.log("fromDate, toDate, checkDate", fromDate, toDate, checkDate)
    let dateFrom = fromDate
    let dateTo = toDate
    let dateCheck = checkDate
    let d1 = dateFrom.split("/");
    let d2 = dateTo.split("/");
    let c = dateCheck.split("/");
    let from = new Date(d1);  // -1 because months are from 0 to 11
    let to = new Date(d2);
    let check = new Date(c);
    const checkFlag = check <= from && check >= to
    return check >= from && check <= to
  }
  // UTILITY


  checkQueryparams() {
    this._activatedRoute.queryParams.subscribe((params: any) => {
      // console.log("DECODE URL" , decodeURIComponent(params) , JSON.stringify(decodeURI(params)) , params , decodeURIComponent(this._router.url))
      if (params && params.isDialog && this.operativeTimelogs && this.operativeTimelogs.length) {
        const date = moment(params.date).format("DD-MM-YYYY")
        console.log("QUERY PARAMS DATA", params, this.operativeTimelogs, date)
        const element = this.operativeTimelogs.find((x) => x.date == params.date)
        console.log("THIS IS THE ELEMENT TO OPEN", element)
        if (element != undefined) {
          const logData = element.logs.find((x) => x.log._id == params.log)
          console.log("LOG DATA TO BE SEND", logData)
          this.addComent(params.mainIndex, logData, logData.index)
        }
      }
    })
  }


  addComent(mainIndex, dayData, dayIndex) {
    console.log("MAIN INDEX", mainIndex);
    console.log("DAy Index", dayData);
    console.log("SINGLE DATE INDEX", dayIndex);
    console.log("SINGLE JOB DETAILS", this.singlejobDetails)
    let data = {
      isRemark: true,
      userId: dayData.userId,
      logId: dayData.log._id,
      remarks: dayData.log.remarks || [],
      date: moment(dayData.log.date).format("DD/MM/YYYY"),
      urlDate: moment(dayData.log.date).format("DD-MM-YYYY"),
      // jobtitle: this.currentJobData.jobTitle,
      notificationData: {
        // clientList: this.singlejobDetails.clients,
        jobId: this.currentJob,
        mainIndex: mainIndex
      },
      isTimesheet: true
    };
    console.log("DATA TO BE SEND FOR VIEW COMMENTS", data)
    this._utilityService
      .commonDialogBoxOpen(
        CommentsComponent,
        data,
        "100vh",
        "100vh"
      )
      .afterClosed()
      .subscribe((commentAdded) => {
        console.log("commentAdded", commentAdded);
        if (commentAdded == undefined) return;
        else {
          if (commentAdded.success) {
            console.log("REMARK ADD FOR SPECIFIC DATA", commentAdded);
            const subObjIndex = this.operativeTimelogs[
              mainIndex
            ].logs.findIndex((y) => y.index === dayIndex);
            console.log("SUBOBJECT INDEX", subObjIndex);
            let latestComment = commentAdded.success.data.logs.find(
              (x) => x._id == dayData.log._id
            );
            console.log("LATEST COMMENT DATA", latestComment);
            this.dataSource[mainIndex].logs[subObjIndex].log["remarks"] =
              latestComment.remarks;
            console.log("DATA SOURCE AFTER UPDATE", this.dataSource);
            // this._utilityService.handleSnackBar({ msg: "Comment Added Successfully", button: "OK" })
          }
          if (commentAdded.error) console.log("THIS IS FOR ERROR");
        }
      });
  }


  checkSelectionTimelog(event, item) {
    console.log("item : ", item);
    // let status;
    if (event && event.checked === true) {
      const obj = {
        logId: item.log._id,
        userId: item.userId,
        status: item.log.status,
        date: item.log.date,
        job: item.log.job, /** @notes adding jobs in individual timelogs for approval. */
      };
      this.selectedTimelog.push(obj);
    } else {
      const index = _.findIndex(this.selectedTimelog, function (o) {
        return o.logId === item.log._id && o.date === item.log.date;
      });
      this.selectedTimelog.splice(index, 1);
    }
    console.log("this.selectedTimelog :: ", this.selectedTimelog);
  }


  compareAssetCategoryObjects(o1: any, o2: any): boolean {
    // console.log("COMAPARE OBJ", o1, o2);
    return o1._id === o2._id
  }

  compareAssetObjects(o1: any, o2: any): boolean {
    // console.log("COMAPARE OBJ", o1, o2);
    return o1._id === o2._id
  }

  compareLinkedObjects(o1: any, o2: any): boolean {
    // console.log("COMAPARE OBJ", o1, o2);
    return o1._id === o2._id
  }


  compareAssetOperatives(o1: any, o2: any): boolean {
    console.log("COMAPARE OBJ", o1, o2);
    return o1._id === o2._id
  }

  updateData(jobs) {
    this.assetsDataSource = new MatTableDataSource(jobs);
    this.assetsDataSource.paginator = this.paginator;
    this.assetsDataSource.sortingDataAccessor = (item, property) => {
      // console.log("item", item, "property", property);
      switch (property) {
        case 'title': return item._id.title;
        default: return item[property];
      }
    };
    this.assetsDataSource.sort = this.sort;
  }


  copyCurrentLogs(mainIndex, i) {
    console.log("INDEX", i, mainIndex);
    this.copiedIndex = i;
    this.mainlogIndex = mainIndex
    this.showPasteBtn = true
    // this.notFileShow = true
  }


  pasteLogs(mainIndex, childIndex, singleLog) {
    // console.log("THIS IS THE MAIN INDEX", this.mainlogIndex, this.copiedIndex, this.operativeTimelogs);
    let mainObjIndex = this.operativeTimelogs.findIndex((x) => x.mainIndex == mainIndex)
    let subObjIndex = this.operativeTimelogs[mainObjIndex].logs.findIndex((y) => y.index == childIndex)
    let preObjIndex = this.operativeTimelogs[this.mainlogIndex].logs.findIndex((z) => z.index == this.copiedIndex)
    let preObj = this.operativeTimelogs[this.mainlogIndex].logs[preObjIndex].log
    let currentObj = this.dataSource[mainObjIndex].logs[subObjIndex].log
    let multipleExpenseList = []
    if (preObj.multipleExpense && preObj.multipleExpense.length) {
      preObj.multipleExpense.filter((x) => {
        multipleExpenseList.push({
          expenseType: x.expenseType,
          expenseAmount: x.expenseAmount,
          expenseEvidence: x.expenseEvidence,
          // expenseDate: this._userTimeSheetService.covertDateFormate(currentObj.date, 'MM/DD/YYYY'),
          expenseDate: currentObj.date,
          userId: x.userId
        })
      })
    }
    let multipleDeductionList = []
    if (preObj.multipleDeduction && preObj.multipleDeduction.length) {
      preObj.multipleDeduction.filter((x) => {
        multipleDeductionList.push({
          deductionType: x.deductionType,
          deductionAmount: x.deductionAmount,
          deductionDate: currentObj.date,
          // deductionDate: this._userTimeSheetService.covertDateFormate(currentObj.date, 'MM/DD/YYYY'),
          userId: x.userId
        })
      })
    }
    console.log("WHAT IS IN THE PRE OBJ DATA", preObj)
    currentObj['start'] = preObj.start
    currentObj['end'] = preObj.end
    currentObj['travel'] = preObj.travel
    currentObj['workingHours'] = preObj.workingHours
    currentObj['workingColor'] = preObj.workingColor
    currentObj['totalHours'] = preObj.totalHours
    currentObj['totalColor'] = preObj.totalColor
    currentObj['details'] = preObj.details
    currentObj['multipleLogs'] = preObj.multipleLogs
    currentObj['multipleExpense'] = multipleExpenseList
    currentObj['date'] = currentObj.date
    currentObj['multipleDeduction'] = multipleDeductionList
    this.dataSource[mainObjIndex].logs[subObjIndex].log = currentObj
    console.log("AFTER UPDATE THE PASTE OBJECT", currentObj, this.dataSource)
    this.showPasteBtn = false
    this._utilityService.handleSnackBar({ msg: "Logs will be paste after save!", button: "OK" })
  }

  resetCurrentLogs(mainIndex, index) {
    console.log("mainIndex", mainIndex, index)
    let elementIndex = this.dataSource[mainIndex].logs.findIndex((x) => x.index == index)
    console.log("FINA INDEX", elementIndex)
    let currentObj = this.dataSource[mainIndex].logs[elementIndex].log
    currentObj['start'] = '00:00'
    currentObj['end'] = '00:00'
    currentObj['travel'] = '00:00'
    currentObj['workingHours'] = '00:00'
    currentObj['workingColor'] = 'green'
    currentObj['totalHours'] = '00:00'
    currentObj['totalColor'] = 'green'
    currentObj["multipleExpense"] = [];
    currentObj["multipleLogs"] = [];
    currentObj["details"] = {};
    this.dataSource[mainIndex].logs[elementIndex].log = currentObj
    // if (this.dataSource[mainIndex].logs[index]._id && this.dataSource[mainIndex].logs[index]._id != 'new') {
    //   this.deletedLog.push(this.dataSource[mainIndex].logs[index]._id)
    // }
  }

  edit(data) {
    console.log("DATA OF EDIT LOGS", data, this.singlejobDetails);
    data.log['extraDetails'] = data.log.details && data.log.details.extraDetails ? data.log.details.extraDetails : ''
    data.log['livingAllowance'] = data.log.details && data.log.details.livingAllowance ? data.log.details.livingAllowance : false
    data.log['payRate'] = data.log.details && data.log.details.payRate ? data.log.details.payRate : ''
    data.log['paidHours'] = data.log.details && data.log.details.paidHours ? data.log.details.paidHours : false
    data.log['expense'] = data.log.details && data.log.details.expense ? data.log.details.expense : false
    data.log['deduction'] = data.log.details && data.log.details.deduction ? data.log.details.deduction : false
    data.log['projectCode'] = this.getProjectCode()
    data.log['date'] = moment(data.log.date).format("DD/MM/YYYY")
    let value = data.log
    // value['multipleLogs'] = [data.log]
    let obj = {
      data: { value: value },
      name: data.name,
      // deletedLog: this.deletedLog,
      learner: data.userId,
      previousDayLog: [],
      jobArray: [{ _id: this.singlejobDetails._id, jobTitle: this.singlejobDetails.jobTitle, projectCode: this.getProjectCode() }],
      projectCodeList: [this.getProjectCode()],
      clientList: [this.singlejobDetails.clients[0].client],
      // previousDayLog: this.getPreviousDayLog(val.value, i),
      isInstructor: true,
      type: 'adminSheet',
      isName: true,
      _isLabourTimeSheet: true
      // selectedProjectCode: this.getProjectCode()
    }

    this._utilityService.commonDialogBoxOpen(JobHoursModelComponent, obj).afterClosed().subscribe((added) => {
      // console.log("ADDED", added);
      if (added == undefined) {
        console.log("BEFORE CHANGE DATA", data)
        data.log['date'] = this._userTimeSheetService.covertDateFormate(data.log.date, 'MM/DD/YYYY')
        console.log("THIS IS THE DATA TO BE", data)
        return;
      }
      else {
        // this._utilityService.handleSnackBar({ msg: "Logs will be paste after save!", button: "OK" })
        // this.addCalculation.emit({ isCal: true })
        this.getJobDetails()
      }
    })

  }

  getProjectCode() {
    return this.singlejobDetails.clients && this.singlejobDetails.clients.length && this.singlejobDetails.clients[0].projectCode != undefined ? this.singlejobDetails.clients[0].projectCode : []
  }


  submitTimelogForApproval() {
    let modalContent;
    let next_action;
    if (this.user.isOperative) {
      modalContent = _operativeTimesheetModalData;
      next_action = "submitted";
    } else {
      modalContent = _adminTimesheetApprovalModalData;
      next_action = "approved";
    }
    let data = {
      modalContent: modalContent,
      timeLogs: this.selectedTimelog,
      displayDates: this.getUniquedate(this.selectedTimelog),
      isApproval: true,
    };
    this._utilityService
      .commonDialogBoxOpen(CommentsComponent, data)
      .afterClosed()
      .subscribe((res) => {
        console.log("THIS IS THE RESPONSE", res)
        if (res) {
          const payload = {
            logs: this.selectedTimelog,
            next_action: next_action
          };
          console.log("checking payload :: ", payload);
          this._labourjobService.submitTimelogForApproval(payload, true).subscribe((data) => {
            console.log("DATA AFTER UPDATED", data)
            let jobData = data.displayJobs[0];
            this.operativeTimelogs = jobData.operativeLogs;
            this.filterTimeloList();
            this.selectedTimelog = [];
            this._utilityService.openSnackBar("Logs have been submitted for approval.", "OK")
          },
            (error) => {
              console.log("Error from updating timelogs : ", error);
              this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" })
            });
        } else {
          this.selectedTimelog = [];
        }
      });
  }


  /**
 * This function will reject Timelog.
 * Only Client and Admin can reject the Timelog.
 */
  submitTimelogForRejection() {
    let modalContent;
    modalContent = _adminTimesheetRejectionModalData;
    let data = {
      modalContent: modalContent,
      timeLogs: this.selectedTimelog,
      isApproval: true,
    };
    const dialogRef = this._utilityService
      .commonDialogBoxOpen(CommentsComponent, data)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const newList = this.selectedTimelog.map(({ date, ...rest }) => {
            return rest;
          });
          const payload = {
            logs: this.selectedTimelog,
            jobId: this.currentJob,
            next_action: "reject",
          };
          console.log("checking payload for rejection :: ", payload);
          this._labourjobService.submitTimelogForApproval(payload, true).subscribe(
            (data) => {
              let jobData = data.displayJobs[0];
              this.operativeTimelogs = jobData.operativeLogs;
              this.filterTimeloList();
              this.selectedTimelog = [];
              this._utilityService.openSnackBar("Logs are successfully rejected and moved for operative resubmission.", "OK");
            },
            (error) => {
              console.log("Error from updating timelogs : ", error);
              this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
            }
          );
        }
      });
  }


  filterTimelogStatus(status) {
    console.log("status ::: ", status);
    if (status === "all") {
      this.dataSource = this.operativeTimelogs;
      this.timelogStatus = "all";
      this.isDataSourceAvailable = true;
    } else {
      if (this.user.isOperative) {
        this.timelogStatus = status;
      }
      //  else if (this.user.isClient) {
      //   if (status === "pending") this.timelogStatus = "approval1";
      //   else if (status === "approved") this.timelogStatus = "approval2";
      // } 
      else if (this.user.isAdmin) {
        if (status === "pending") this.timelogStatus = "submitted";
        else if (status === "approved") this.timelogStatus = "approved";
      }
      this.filterTimeloList();
    }
  }



  filterTimeloList() {
    console.log("timelogStatus ::: ", this.timelogStatus);
    if (this.timelogStatus == "all") {
      this.dataSource = this.operativeTimelogs;
      this.isDataSourceAvailable = true;
    } else {
      let tempDateList = JSON.parse(JSON.stringify(this.operativeTimelogs));
      let filteredTimelogList: any = [];
      tempDateList.forEach((timelog) => {
        let _timelog = { ...timelog };
        let _logs = [];
        timelog.logs.forEach((logs) => {
          if (logs.log.status === this.timelogStatus) _logs.push(logs);
        });
        _timelog.logs = _logs;
        if (_logs.length > 0) filteredTimelogList.push(_timelog);
      });
      console.log("checking filteredTimelogList :: ", filteredTimelogList);
      if (filteredTimelogList.length) {
        this.dataSource = filteredTimelogList;
        this.isDataSourceAvailable = true;
      } else {
        this.isDataSourceAvailable = false;
      }
    }
  }


  getUniquedate(logs) {
    console.log("LOGS DATA TO BE CONSIDER", logs)
    let datesArray = []
    const logsLength = logs.length
    for (let index = 0; index < logsLength; index++) {
      const element = datesArray.find((x) => x === moment(logs[index].date).format("DD-MM-YYYY"))
      console.log("ELEMENT DATA", element, moment(logs[index].date).format("DD-MM-YYYY"))
      if (element == undefined) datesArray.push(moment(logs[index].date).format("DD-MM-YYYY"))
    }
    return datesArray
  }

  // API CALL 


  submitDetail() {
    let logsArray = []
    const logLength = this.operativeTimelogs.length
    for (let i = 0; i < logLength; i++) {
      let singledayLength = this.operativeTimelogs[i].logs.length
      for (let j = 0; j < singledayLength; j++) {
        let singleDate = this.operativeTimelogs[i].logs[j].log
        if ((singleDate.start != '00:00' || singleDate.end != '00:00' || singleDate._id != 'new')) {
          let temp = {
            _id: singleDate._id,
            details: {},
            // date: singleDate.date,
            date: singleDate.date,
            hours: singleDate.hours,
            minutes: singleDate.minutes,
            workingHours: singleDate.workingHours,
            start: singleDate.start,
            end: singleDate.end,
            job: singleDate.job,
            travel: singleDate.travel,
            totalHours: singleDate.totalHours,
            userId: this.operativeTimelogs[i].logs[j].userId,
            multipleLogs: singleDate.multipleLogs,
            multipleExpense: singleDate.multipleExpense,
            multipleDeduction: singleDate.multipleDeduction,
          }
          temp.details = {
            extraDetails: singleDate.details.extraDetails,
            livingAllowance: singleDate.details.livingAllowance,
            payRate: singleDate.details.payRate,
            paidHours: singleDate.details.paidHours,
            expense: singleDate.details.expense,
            deduction: singleDate.deduction,
          }
          logsArray.push(temp);
        }
      }
    }
    // console.log("THIS IS THE LOGS ARRAY TO BE UPDATE", logsArray);
    let finalArray = []
    if (logsArray && logsArray.length) {
      const logsLength = logsArray.length
      for (let i = 0; i < logsLength; i++) {
        let obj = {
          date: [],
          learner: logsArray[i].userId,
          type: 'adminSheet'
        }
        let index = finalArray.findIndex((x) => x.learner == logsArray[i].userId)
        if (index != -1) {
          finalArray[index].date.push(logsArray[i])
        } else {
          obj.date = [logsArray[i]]
          finalArray.push(obj)
        }
      }

    }
    console.log("OUT PUT OF LOG ARRAY TO BE ADDED", finalArray);
    this._labourjobService.addmultipleUserslogs(finalArray, this.currentJob).subscribe((data) => {
      // console.log("DATA is updated", data);
      let jobData = data.displayJobs[0]
      this.operativeTimelogs = jobData.operativeLogs
      this._utilityService.openSnackBar("Logs added successfully!", "OK")
    })
  }
  // fatigueIndexCalculation() {
  fatigueIndexCalculation(user) {
    // console.log("current selected user", user);
    // if (this.user.isOperative) {
    const data = {
      userId: user.userId,
      type: 'fatigue'
    }
    // console.log("this is the data to be send", data);
    this._userTimeSheetService.getFatigueIndex(JSON.stringify(data)).subscribe((response) => {
      // console.log("response of fatigue index", response);
      // this.isCalculation = true
      // this.addCalculation.emit({ isCal: true })
      this.getJobDetails()
    }, err => {
      // console.log("error while get fatigue index", err);
    })
    // }
  }

  getJobDetails() {
    this._labourjobService.getSingleLabourjob(this.currentJob).subscribe((res) => {
      console.log("RESPONE OF JOB DETAILS", res);

      let jobData = res.displayJobs[0]
      this.operativeTimelogs = jobData.operativeLogs
      this.dataSource = this.operativeTimelogs
    })

  }


  getJobData() {
    this.loading = true
    this._labourjobService.getRequiredjobData('test1').subscribe((data) => {
      this.assetCategoryList = data.assetList
      this.loading = false
      this.createForm(this.linkedAssetList)
      this.disableAssets()
      // console.log("OTHER REQUIRED DATA FOR CREATE AND EDIT JOB", this.assetCategoryList)
    }, error => {
      console.log("ERROR WHILE GET DATA", error);
      this.loading = false
    })
  }

  updateAsset() {
    // console.log("EDIT ASSET DATA", this.labourjobForm.value);
    // console.log("CURRENT JOB", this.currentJob);
    if (!this.isDisabled) {
      let data = this.labourjobForm.value
      this._labourjobService.editLabourjob(data, this.currentJob).subscribe((res) => {
        this._utilityService.handleSnackBar({ msg: "Asset allocated successfully!", button: "Ok" })
        this.loading = false
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong", button: "Ok" })
        this.loading = false
      })
    } else {
      console.log("THIS IS FOR NO DATA");

    }
  }


  /**
    * This function will submit all the appropriate timelogs for Approval(Operatives users only).
    */
  submitAllTimelogForApproval() {
    /** @note if selectedTimelog has already timelogs then remove first and add new timelogs. */
    this.selectedTimelog = [];
    for (let i = 0; i < this.operativeTimelogs.length; i++) {
      let timelogs = this.operativeTimelogs[i];
      console.log('timelogs :: ', timelogs);
      for (let j = 0; j < timelogs.logs.length; j++) {
        if (timelogs.logs[j].log.status === 'draft') {
          const obj = {
            logId: timelogs.logs[j].log._id,
            userId: timelogs.logs[j].userId,
            status: timelogs.logs[j].log.status,
            date: timelogs.logs[j].log.date,
            job: timelogs.logs[j].log.job, /** @notes adding jobs in individual timelogs for approval. */
          };
          this.selectedTimelog.push(obj);
        }
      }
    }
    console.log("this.selectedTimelog :: ", this.selectedTimelog);
    if (this.selectedTimelog.length) {
      this.submitTimelogForApproval();
    } else {
      this._utilityService.openSnackBar(
        "No logs are eligible for Approval.",
        "OK"
      );
    }
  }

  // }
}
